import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (typeof SignaturePad !== 'undefined') {
      const studentCanvas = this.element.querySelector("#student-signature-canvas");
      const guardianCanvas = this.element.querySelector("#guardian-signature-canvas");
      
      if (studentCanvas) {
        this.studentSignaturePad = new SignaturePad(studentCanvas);
      }
      if (guardianCanvas) {
        this.guardianSignaturePad = new SignaturePad(guardianCanvas);
      }
    }
  }

  clearStudentSignature(event) {
    if (this.studentSignaturePad) {
      this.studentSignaturePad.clear();
    }
  }

  clearGuardianSignature(event) {
    if (this.guardianSignaturePad) {
      this.guardianSignaturePad.clear();
    }
  }

  saveStudentSignature(event) {
    // Always save the signature value if it exists
    if (this.studentSignaturePad) {
      const signatureInput = this.element.querySelector("#student_signature");
      if (signatureInput) {
        signatureInput.value = this.studentSignaturePad.toDataURL();
      }
      
      // Check if signature is required and empty
      const signatureSection = this.element.querySelector("#student-signature");
      const isSignatureRequired = !signatureSection || 
                                  !signatureSection.classList.contains("u-hidden");
      
      if (this.studentSignaturePad.isEmpty() && isSignatureRequired) {
        event.preventDefault();
        alert("Please sign before submitting");
        if (event.currentTarget) {
          event.currentTarget.disabled = false;
        }
      }
    }
  }

  hideExistingSignatureAndShowCanvas() {
    const newSignature = this.element.querySelector("#new-signature")
    const existingSignature = this.element.querySelector("#existing-signature")    

    newSignature.hidden = false
    existingSignature.hidden = true
  }

  saveGuardianSignature(event) {
    // Always save the guardian signature value if it exists
    if (this.guardianSignaturePad) {
      const guardianInput = this.element.querySelector("#guardian_signature");
      if (guardianInput) {
        guardianInput.value = this.guardianSignaturePad.toDataURL();
      }
    }
  }
}
